import { __rest } from '../../../_virtual/_tslib.js';
import React from 'react';
import PropTypes from 'prop-types';
import { getDecadeEnd, getDecadeStart } from '@wojtekmaj/date-utils';
import Tile from '../Tile.js';
import { getDecadeLabel } from '../shared/dates.js';
import { formatYear } from '../shared/dateFormatter.js';
import { tileProps } from '../shared/propTypes.js';

const className = 'react-calendar__century-view__decades__decade';
function Decade(_a) {
  var {
      classes,
      formatYear: formatYear$1 = formatYear
    } = _a,
    otherProps = __rest(_a, ["classes", "formatYear"]);
  const {
    date,
    locale
  } = otherProps;
  return React.createElement(Tile, Object.assign({}, otherProps, {
    classes: [].concat(classes, className),
    maxDateTransform: getDecadeEnd,
    minDateTransform: getDecadeStart,
    view: "century"
  }), getDecadeLabel(locale, formatYear$1, date));
}
Decade.propTypes = Object.assign(Object.assign({}, tileProps), {
  formatYear: PropTypes.func
});

export { Decade as default };
